import { ERR_INVALID_ARGUMENT } from "../error";
import { isNullOrEmpty, isDataUri } from "../string";
/**
 * Converts an ArrayBuffer into a Base64 encoded string.
 */
export function toBase64(pBuffer) {
    if (pBuffer == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    let tByteStr = "";
    const tBytes = new Uint8Array(pBuffer);
    const tLen = tBytes.byteLength;
    for (let i = 0; i < tLen; i++) {
        tByteStr += String.fromCharCode(tBytes[i]);
    }
    return (btoa(tByteStr));
}
/**
 * Converts an ArrayBuffer into a hex (Base16) encoded string.
 */
export function toHex(pBuffer) {
    if (pBuffer == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    const tBytes = new Uint8Array(pBuffer);
    const tLen = tBytes.byteLength;
    let tHexStr = "";
    for (let i = 0; i < tLen; i++) {
        tHexStr += tBytes[i].toString(16).padStart(2, "0");
    }
    return (tHexStr);
}
/**
 * Converts an ArrayBuffer into a data uri.
 */
export function toDataUri(pBuffer, pMimeType) {
    if (pBuffer == null || isNullOrEmpty(pMimeType))
        throw new Error(ERR_INVALID_ARGUMENT);
    return ("data:" + pMimeType + ";base64," + toBase64(pBuffer));
}
/**
 * Converts a Base64 encoded string into an ArrayBuffer.
 */
export function fromBase64(pBase64Str) {
    if (isNullOrEmpty(pBase64Str))
        throw new Error(ERR_INVALID_ARGUMENT);
    const tByteStr = atob(pBase64Str);
    const tLen = tByteStr.length;
    const tBytes = new Uint8Array(tLen);
    for (let i = 0; i < tLen; i++) {
        tBytes[i] = tByteStr.charCodeAt(i);
    }
    return (tBytes.buffer);
}
/**
 * Converts a data uri into an ArrayBuffer.
 */
export function fromDataUri(pDataUri) {
    if (!isDataUri(pDataUri))
        throw new Error(ERR_INVALID_ARGUMENT);
    return (fromBase64(pDataUri.split(",")[1]));
}
/**
 * Converts a Blob into an ArrayBuffer.
 */
export function fromBlob(pBlob) {
    if (pBlob == null)
        return (Promise.reject(new Error(ERR_INVALID_ARGUMENT)));
    const tPromise = new Promise((pResolve, pReject) => {
        const tFileReader = new FileReader();
        tFileReader.onload = () => {
            pResolve(tFileReader.result);
        };
        tFileReader.onerror = () => {
            if (tFileReader.error != null)
                pReject(new Error("Failed to read from blob: " + tFileReader.error.name));
            else
                pReject(new Error("Failed to read from blob."));
        };
        tFileReader.readAsArrayBuffer(pBlob);
    });
    return (tPromise);
}
/**
 * Computes the hash for the given buffer and returns it as hex string.
 * Note: This function requires a secure connection (HTTPS).
 */
export async function hash(pBuffer, pAlgorithm) {
    //hash the data
    const tHashBuffer = await crypto.subtle.digest(pAlgorithm, pBuffer);
    //convert to hex string
    return (toHex(tHashBuffer));
}
